//Custom colors
import Colors from "../../Assets/SassConstants/colors.scss";

const FooterColorLineData = [
  {
    id: 1,
    color: Colors.red_1,
  },
  {
    id: 2,
    color: Colors.red_2,
  },
  {
    id: 3,
    color: Colors.red_3,
  },
  {
    id: 4,
    color: Colors.grey_1,
  },
  {
    id: 5,
    color: Colors.green_1,
  },
  {
    id: 6,
    color: Colors.blue_1,
  },
  {
    id: 7,
    color: Colors.blue_2,
  },
  {
    id: 8,
    color: Colors.blue_3,
  },
];

export default FooterColorLineData;
